<script>
export default {
  name: 'RouteView',
  props: {
    keepAlive: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  render() {
    const inKeep = (
      <keep-alive>
        <router-view />
      </keep-alive>
    );
    return inKeep;
  },
};
</script>
